import "esbuild-css-modules-plugin-ns-css:src/js/pages/providerStep/providerStep.module.css";

import { inject } from "esbuild-css-modules-plugin-ns-js:src/js/pages/providerStep/providerStep.module.css:injector.js";
export default new Proxy({
  "mobileH2": "providerStep-module__mobileH2_C03YYq__1100",
  "multiCardContainer": "providerStep-module__multiCardContainer_C03YYq__1100",
  "pageContainer": "providerStep-module__pageContainer_C03YYq__1100"
}, {
  get: function(source, key) {
    inject();
    return source[key];
  }
});
      